import { IUserMe } from '../interfaces/user';

const InterceptorConfig = async (config: any) => {
    const itemUserMe = (await localStorage.getItem('userme')) || '';
    const userMe = itemUserMe
        ? (JSON.parse(itemUserMe) as IUserMe)
        : ({} as IUserMe);
    const token = userMe ? userMe?.token : '';

    config.headers.authorization = `Bearer ${token}`;

    return config;
};

const InterceptorError = (err: any) => {
    return Promise.reject(err);
};

export { InterceptorConfig, InterceptorError };
